module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_planner@2x-cc899411940c3f359a42543c60e38638.webp";